export { default } from './PatientDetailsSidebar';
